import { useCallback } from 'react';

import { fetchPlayerConfigAction } from '../apiActions/fetchPlayerConfigAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const usePlayerConfigFetcher = (essential: boolean): (() => void) => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const baseUrl = useConfigSlice.baseUrl();

  return useCallback(() => {
    if (JSESSIONID && baseUrl) {
      dispatch(
        fetchPlayerConfigAction({
          JSESSIONID,
          baseUrl,
          essential,
        })
      );
    }
  }, [JSESSIONID, baseUrl, dispatch, essential]);
};
